import {Box} from '@mui/material'
import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import LayoutDefault from 'src/pages/camera-mosaic/components/LayoutDefault'
import api, {Camera, Layout} from 'src/services/api'

function LayoutShow() {
  const [cameras, setCameras] = useState<Camera[]>([])

  const [layout, setLayout] = useState<Layout>()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const id = +params.get('id')!
    loadLayout(id)
  }, [location])

  async function loadLayout(id: number) {
    if (id === 0) return
    const response = await api.layout.getMany({
      filter: {
        ids: [id],
      },
      includes: ['cameras', 'cameras.camera'],
    })

    const mosaico = response.data.data.entities[0]
    const cam: Camera[] = mosaico.cameras?.map((cam) => cam.camera).filter((it): it is Camera => !!it) ?? []
    if (cam && cam.length) setCameras(cam)
    setLayout(mosaico)
  }

  return (
    <Box width='100vw' height='100vh'>
      <LayoutDefault cameras={cameras} layoutType={layout?.layoutTypeId ?? 1} showBarriers={false} />
    </Box>
  )
}

export default LayoutShow
